/* ============================================================
   Fique Bonita — theme.js
   Sem jQuery. Custom elements: cada componente cuida de si e
   nao existe um "main" que sabe de tudo.
   ============================================================ */
(() => {
  'use strict';

  const CFG = window.FB_CONFIG || {};
  const T = CFG.t || {};

  /* ----------------------------------------------------------
     Avisos para leitor de tela
     A regiao ja nasce no HTML e vazia. Leitor de tela so anuncia
     mudanca dentro de uma regiao que JA existia — criada na hora,
     ele nao fala.
     ---------------------------------------------------------- */
  const liveRegion = document.querySelector('[data-announce]');
  function announce(msg, urgency = 'polite') {
    if (!liveRegion || !msg) return;
    liveRegion.setAttribute('aria-live', urgency);
    liveRegion.textContent = '';
    setTimeout(() => { liveRegion.textContent = msg; }, 60);
  }
  window.FBAnnounce = announce;

  /* ---------------------------------------------------------- */
  function money(cents) {
    return (cents / 100).toLocaleString('pt-BR', {
      style: 'currency', currency: CFG.currency || 'BRL'
    });
  }

  /* Roda o callback quando o elemento chega perto da tela. Serve para adiar
     busca de dados de secao que vive no fim da pagina. */
  function whenVisible(el, fn, margin = '300px') {
    if (!('IntersectionObserver' in window)) return fn();
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) { io.disconnect(); fn(); }
    }, { rootMargin: margin });
    io.observe(el);
  }
  window.FBWhenVisible = whenVisible;

  /* prefers-reduced-motion nao alcanca rolagem feita por JS: o media query do
     CSS so zera duracao e zoom. Aqui a checagem e explicita. */
  const menosMovimento = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const comportamentoRolagem = () => (menosMovimento() ? 'auto' : 'smooth');

  function trapFocus(container) {
    const sel = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';
    function onKey(e) {
      if (e.key !== 'Tab') return;
      const items = [...container.querySelectorAll(sel)].filter((el) => el.offsetParent !== null);
      if (!items.length) return;
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKey);
    return () => container.removeEventListener('keydown', onKey);
  }

  /* ----------------------------------------------------------
     Carrinho
     ---------------------------------------------------------- */
  const Cart = {
    async add(items) {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      const data = await r.json();
      if (!r.ok) throw data;
      return data;
    },
    async change(key, quantity) {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const data = await r.json();
      if (!r.ok) throw data;
      return data;
    },
    async get() {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      return r.json();
    }
  };
  window.FBCart = Cart;

  /* Recarrega apenas as secoes do carrinho, sem recarregar a pagina. */
  async function refreshCart() {
    const alvos = [
      ['cart-drawer', '#cart-drawer'],
      // 'main' e o ID DA SECAO em templates/cart.json; '#main-cart' e o id do
      // elemento no DOM. Sao coisas diferentes e estavam trocados: a API de
      // secoes recebia ?sections=main-cart, nao achava secao com esse nome e
      // devolvia vazio. Resultado: remover peca ou mudar quantidade na pagina
      // /cart nao mudava nada na tela ate recarregar.
      ['main', '#main-cart']
    ];
    const presentes = alvos.filter(([, sel]) => document.querySelector(sel));
    if (!presentes.length) {
      updateCartCount(await Cart.get());
      return;
    }
    const nomes = presentes.map(([id]) => id).join(',');
    // Uma ida so. Antes eram duas em serie (secoes + /cart.js) so para saber o
    // numero do contador — em 4G isso segurava a gaveta fechada por quase 1s.
    const [html, cart] = await Promise.all([
      fetch(`${window.location.pathname}?sections=${nomes}`).then((r) => r.json()).catch(() => null),
      Cart.get()
    ]);
    if (html) {
      presentes.forEach(([id, sel]) => {
        if (!html[id]) return;
        const novo = new DOMParser().parseFromString(html[id], 'text/html').querySelector(sel);
        const atual = document.querySelector(sel);
        if (novo && atual) atual.innerHTML = novo.innerHTML;
      });
    }
    updateCartCount(cart);
  }
  window.FBRefreshCart = refreshCart;

  function updateCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    // O aria-label do botao sobrescreve o conteudo, entao a quantidade nunca
    // seria anunciada se ficasse so no <span>.
    document.querySelectorAll('[data-cart-button]').forEach((b) => {
      b.setAttribute('aria-label', cart.item_count === 1
        ? 'Sua sacola, 1 item'
        : `Sua sacola, ${cart.item_count} itens`);
    });
  }

  /* ----------------------------------------------------------
     Ida para o checkout do app (Zedy)

     O app so troca o botao na PAGINA do carrinho. A gaveta abre em
     qualquer lugar, entao daqui o submit escaparia para o checkout
     da Shopify, furando o app.

     Caminho rapido: fakeClick() do proprio app — ele le /cart.json,
     pergunta a URL do checkout e redireciona, sem carregar a pagina
     do carrinho no meio.
     Caminho garantido: /cart/?skipCart=1, a rota publica dele.
     ---------------------------------------------------------- */
  function irParaCheckoutApp(e) {
    // Zedy e Yampi funcionam do mesmo jeito: os dois procuram o botao nativo
    // name="checkout" dentro do form /cart, escondem ele e poem o deles. E os
    // dois so agem quando o template e 'cart'. A gaveta abre em qualquer pagina,
    // por isso o desvio existe — muda so a rota de cada um.
    if (CFG.appCheckout === 'yampi') {
      announce(CFG.checkoutLoaderText || 'Levando você para o pagamento seguro.', 'assertive');
      if (typeof window.yampiClick === 'function') { window.yampiClick(); return; }
      window.location.href = '/cart?ref=yampi_buy_button';
      return;
    }
    if (typeof window.fakeClick === 'function') {
      // O texto da tela de espera vive num ::after do CSS, e conteudo gerado por
      // CSS nao chega ao leitor de tela. No momento mais tenso da compra, quem
      // nao enxerga ficaria sem nenhum retorno.
      announce(CFG.checkoutLoaderText || 'Levando você para o pagamento seguro.', 'assertive');
      try { if (typeof window.showchtLoader === 'function') window.showchtLoader(); } catch (_) {}
      window.fakeClick(e || new Event('checkout'));
      // Se o app nao redirecionar (script meio carregado, rede ruim), a cliente
      // ficaria com um botao girando para sempre no momento mais tenso da compra.
      setTimeout(() => {
        if (!document.hidden) window.location.href = '/cart/?skipCart=1';
      }, 6000);
      return;
    }
    window.location.href = '/cart/?skipCart=1';
  }
  window.FBCheckoutApp = irParaCheckoutApp;

  /* Delegado no document: a gaveta troca o proprio HTML a cada
     atualizacao, e um listener preso ao botao morreria junto. */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-app-checkout]');
    if (!b || b.disabled) return;
    e.preventDefault();
    b.classList.add('btn--loading');
    irParaCheckoutApp(e);
  });

  /* ----------------------------------------------------------
     Gaveta generica (menu, carrinho, filtros)
     ---------------------------------------------------------- */
  class FBDrawer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-drawer-close]') || e.target.hasAttribute('data-drawer-scrim')) {
          this.close();
        }
      });
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || !this.classList.contains('is-open')) return;
        const abertos = document.querySelectorAll('fb-drawer.is-open, fb-modal.is-open');
        if (abertos[abertos.length - 1] !== this) return;
        this.close();
      });
      // Guardar os gatilhos: e' neles que o estado precisa aparecer. Sem isso o
      // botao continua sendo anunciado como 'recolhido' com a gaveta aberta, e
      // quem usa leitor de tela nao sabe que o mesmo botao agora fecha.
      this._gatilhos = [...document.querySelectorAll(`[data-drawer-open="${this.id}"]`)];
      this._gatilhos.forEach((b) => {
        b.addEventListener('click', (e) => { e.preventDefault(); this.open(); });
      });
    }
    _anuncia(aberto) {
      (this._gatilhos || []).forEach((b) => b.setAttribute('aria-expanded', String(aberto)));
    }
    open() {
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      this._anuncia(true);
      document.body.style.overflow = 'hidden';
      this._prev = document.activeElement;
      this._untrap = trapFocus(this);
      setTimeout(() => this.querySelector('[data-drawer-close]')?.focus(), 50);
    }
    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      if (!document.querySelector('fb-drawer.is-open, fb-modal.is-open')) {
        document.body.style.overflow = '';
      }
      this._untrap?.();
      this._prev?.focus();
    }
  }
  customElements.define('fb-drawer', FBDrawer);

  /* ----------------------------------------------------------
     Popup
     ---------------------------------------------------------- */
  class FBModal extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-modal-close]') || e.target.hasAttribute('data-modal-scrim')) this.close();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || !this.classList.contains('is-open')) return;
        // Com dois popups abertos, Esc fecha so o de cima.
        const abertos = document.querySelectorAll('fb-modal.is-open, fb-drawer.is-open');
        if (abertos[abertos.length - 1] !== this) return;
        this.close();
      });
      document.querySelectorAll(`[data-modal-open="${this.id}"]`).forEach((b) => {
        b.addEventListener('click', (e) => { e.preventDefault(); this.open(); });
      });
    }
    open() {
      this.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this._prev = document.activeElement;
      this._untrap = trapFocus(this);
      setTimeout(() => this.querySelector('[data-modal-close]')?.focus(), 50);
    }
    close() {
      this.classList.remove('is-open');
      if (!document.querySelector('fb-modal.is-open, fb-drawer.is-open')) {
        document.body.style.overflow = '';
      }
      this._untrap?.();
      this._prev?.focus();
    }
  }
  customElements.define('fb-modal', FBModal);

  /* ----------------------------------------------------------
     Quantidade
     ---------------------------------------------------------- */
  class FBQty extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.querySelectorAll('[data-step]').forEach((b) => {
        b.addEventListener('click', () => {
          const passo = parseInt(b.dataset.step, 10);
          const min = parseInt(this.input.min || 1, 10);
          const novo = Math.max(min, (parseInt(this.input.value, 10) || min) + passo);
          if (novo === parseInt(this.input.value, 10)) return;
          this.input.value = novo;
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }
  }
  customElements.define('fb-qty', FBQty);

  /* ----------------------------------------------------------
     Formulario de produto
     ---------------------------------------------------------- */
  class FBProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.btn = this.form.querySelector('[data-add-to-cart]');
      const caixaErro = () => this.querySelector('[data-form-error]');

      const agora = this.form.querySelector('[data-buy-now]');
      if (agora) {
        agora.addEventListener('click', async () => {
          const box = caixaErro();
          if (box) { box.hidden = true; box.textContent = ''; }
          const antes = agora.disabled;
          agora.classList.add('btn--loading');
          agora.disabled = true;
          try {
            await Cart.add([this.linha()]);
            irParaCheckoutApp();
          } catch (err) {
            agora.classList.remove('btn--loading');
            agora.disabled = antes;
            if (box) { box.textContent = this.erro(err); box.hidden = false; }
          }
        });
      }

      this.form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const box = caixaErro();
        if (box) { box.hidden = true; box.textContent = ''; }
        // Guardar o estado anterior: em produto esgotado o botao nasce disabled,
        // e sem isto o finally reabilitaria um botao "Esgotado".
        const eraDesabilitado = this.btn ? this.btn.disabled : false;
        this.btn?.classList.add('btn--loading');
        if (this.btn) this.btn.disabled = true;
        try {
          await Cart.add([this.linha()]);
        } catch (err) {
          if (box) { box.textContent = this.erro(err); box.hidden = false; }
          announce(this.erro(err), 'assertive');
          this.btn?.classList.remove('btn--loading');
          if (this.btn) this.btn.disabled = eraDesabilitado;
          return;
        }
        // Daqui para baixo o item JA esta na sacola. Se redesenhar falhar, o pior
        // caso e a tela ficar desatualizada — nunca dizer que a compra falhou.
        try {
          await refreshCart();
          announce(T.addedToCart || 'Produto adicionado à sacola.');
          if (CFG.cartType === 'drawer') document.getElementById('cart-drawer')?.open();
        } catch (_) {
          window.location.reload();
        } finally {
          this.btn?.classList.remove('btn--loading');
          if (this.btn) this.btn.disabled = eraDesabilitado;
        }
      });
    }
    linha() {
      return {
        id: Number(this.form.querySelector('input[name="id"]').value),
        quantity: parseInt(this.form.querySelector('input[name="quantity"]')?.value || 1, 10)
      };
    }
    erro(err) {
      // err.description vem da API da Shopify e ja chega em portugues. Erro de
      // rede nao tem description e o message e "Failed to fetch" — texto de
      // console, nao de loja.
      if (err && err.description) return err.description;
      if (err instanceof TypeError) return 'Sua conexão caiu. Tente de novo.';
      return 'Não foi possível adicionar à sacola.';
    }
  }
  customElements.define('fb-product-form', FBProductForm);

  /* ----------------------------------------------------------
     Seletor de variante
     ---------------------------------------------------------- */
  class FBVariants extends HTMLElement {
    connectedCallback() {
      const dados = this.querySelector('[type="application/json"]');
      if (!dados) return;
      this.variants = JSON.parse(dados.textContent);
      this.form = document.getElementById(this.dataset.form);
      this.idInput = this.form?.querySelector('input[name="id"]');
      this.selected = this.variants.find((v) => String(v.id) === String(this.idInput?.value)) || this.variants[0];
      this.querySelectorAll('[data-value]').forEach((b) => {
        b.addEventListener('click', () => this.pick(b));
      });
      this.render();
    }
    pick(btn) {
      const idx = parseInt(btn.dataset.optionIndex, 10);
      const val = btn.dataset.value;
      this.querySelectorAll(`[data-option-index="${idx}"]`).forEach((b) => {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      const escolhido = this.querySelector(`[data-picked-for="${idx}"]`);
      if (escolhido) escolhido.textContent = val;

      const escolhas = [];
      this.querySelectorAll('[aria-pressed="true"][data-option-index]').forEach((b) => {
        escolhas[parseInt(b.dataset.optionIndex, 10)] = b.dataset.value;
      });
      const achou = this.variants.find((v) =>
        v.options.every((o, i) => escolhas[i] == null || o === escolhas[i]));

      const box = (this.closest('.product__info') || document).querySelector('[data-form-error]');
      const cta = this.form?.querySelector('[data-add-to-cart]');
      if (achou) {
        this.selected = achou;
        this.render();
        if (box) { box.hidden = true; box.textContent = ''; }
        announce(`${achou.available ? '' : 'Esgotado. '}${money(achou.price)}`);
      } else {
        // Combinacao que nao existe: TODO caminho de compra fecha. Sem desabilitar
        // tambem o "Comprar agora" e sem limpar o input, o clique levava a cliente
        // ao pagamento com a variante anterior — peca errada, troca, reembolso.
        const agoraBtn = this.form?.querySelector('[data-buy-now]');
        if (cta) { cta.disabled = true; cta.textContent = T.unavailable || 'Indisponível'; }
        if (agoraBtn) agoraBtn.disabled = true;
        if (this.idInput) this.idInput.value = '';
        if (box) { box.textContent = T.unavailableCombo || 'Essa combinação não está disponível.'; box.hidden = false; }
        announce(T.unavailableCombo || 'Essa combinação não está disponível.', 'assertive');
      }
    }
    /* Escopo do componente: com document.querySelector, escolher tamanho dentro
       de um popup reescreveria o preco da pagina de fundo. */
    scope() {
      return this.closest('.product__info') || document;
    }
    render() {
      const v = this.selected;
      if (!v) return;
      const raiz = this.scope();
      const q = (s) => raiz.querySelector(s) || document.querySelector(s);
      if (this.idInput) this.idInput.value = v.id;

      const agora = q('[data-price-now]');
      const antes = q('[data-price-was]');
      const off = q('[data-price-off]');
      // lastChild.nodeValue, nao textContent: dentro destes elementos existe um
      // <span class="visually-hidden"> com "Preco:" e "Preco antes:". textContent
      // apagava os dois, e quem usa leitor de tela passava a ouvir dois valores
      // soltos sem saber qual e o de agora — podia entender que a peca subiu.
      const escreve = (el, txt) => {
        if (el.lastChild && el.lastChild.nodeType === 3) el.lastChild.nodeValue = txt;
        else el.append(txt);
      };
      if (agora) escreve(agora, money(v.price));
      if (antes) {
        const temOferta = v.compare_at_price > v.price;
        escreve(antes, temOferta ? money(v.compare_at_price) : '');
        antes.hidden = !temOferta;
        if (off) {
          off.hidden = !temOferta;
          if (temOferta) {
            off.textContent = `-${Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price)}%`;
          }
        }
      }

      const pix = q('[data-price-pix-value]');
      if (pix && CFG.pixDiscount) {
        pix.textContent = money(Math.round(v.price * (100 - CFG.pixDiscount) / 100));
      }

      const inst = q('[data-price-inst]');
      // A chave do editor tem que valer aqui tambem: o Liquid respeitava
      // installments_enable, o JS nao, e a frase 'ou 6x sem juros' voltava
      // sozinha ao trocar de variante. A loja anunciava uma condicao de
      // pagamento que decidiu nao anunciar.
      if (inst && CFG.instEnable && CFG.instMax > 1) {
        let n = CFG.instMax;
        while (n > 1 && v.price / n < CFG.instMin * 100) n--;
        if (n > 1) {
          inst.innerHTML = `ou <strong>${n}x de ${money(v.price / n)}</strong> sem juros`;
          inst.hidden = false;
        } else { inst.hidden = true; }
      }

      const cta = this.form?.querySelector('[data-add-to-cart]');
      if (cta) {
        cta.disabled = !v.available;
        cta.textContent = v.available
          ? (T.addToCart || 'Adicionar à sacola')
          : (T.soldOut || 'Esgotado');
      }
      const agoraBtn = this.form?.querySelector('[data-buy-now]');
      if (agoraBtn) agoraBtn.disabled = !v.available;

      // A URL acompanha a variante: link compartilhado abre na peca certa.
      if (v.id && history.replaceState) {
        const u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u);
      }
      document.dispatchEvent(new CustomEvent('fb:variant', { detail: { variant: v } }));
    }
  }
  customElements.define('fb-variants', FBVariants);

  /* ----------------------------------------------------------
     Galeria de produto
     ---------------------------------------------------------- */
  class FBGallery extends HTMLElement {
    connectedCallback() {
      this.main = this.querySelector('[data-gallery-main]');
      this.thumbs = [...this.querySelectorAll('[data-media-id]')];
      // Comeca na miniatura que o Liquid JA marcou, nao no zero. Quando a
      // primeira variante disponivel tem foto propria, a pagina abre nela — e
      // com this.i = 0 a seta 'proxima' voltava atras em vez de avancar.
      this.i = Math.max(0, this.thumbs.findIndex(
        (t) => t.getAttribute('aria-pressed') === 'true'));
      this.thumbs.forEach((t, n) => t.addEventListener('click', () => this.show(n)));
      this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.show(this.i - 1));
      this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.show(this.i + 1));
      document.addEventListener('fb:variant', (e) => {
        const id = e.detail?.variant?.featured_media?.id;
        if (!id) return;
        const n = this.thumbs.findIndex((t) => String(t.dataset.mediaId) === String(id));
        if (n > -1) this.show(n);
      });
    }
    show(n) {
      if (!this.thumbs.length || !this.main) return;
      const total = this.thumbs.length;
      n = (n + total) % total;
      this.i = n;
      const t = this.thumbs[n];
      // Se o destino ja e o que esta na tela, nao mexe: reatribuir o src faz o
      // navegador descartar o download que ja comecou com prioridade alta e
      // recomecar do zero. Era isso que empurrava o LCP.
      const alvo = t.dataset.full;
      if (alvo && this.main.getAttribute('src') !== alvo) {
        this.main.src = alvo;
        this.main.srcset = t.dataset.srcset || '';
        if (t.dataset.alt) this.main.alt = t.dataset.alt;
      }
      this.thumbs.forEach((x, k) => {
        x.classList.toggle('is-on', k === n);
        x.setAttribute('aria-pressed', k === n ? 'true' : 'false');
      });
      if (this._pronta) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: comportamentoRolagem() });
      this._pronta = true;
    }
  }
  customElements.define('fb-gallery', FBGallery);

  /* ----------------------------------------------------------
     Carrossel horizontal
     ---------------------------------------------------------- */
  class FBCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      // Os botoes saem de dentro do <fb-carousel> quando a section usa a
      // casca (.carousel-shell): la fora eles escapam do overflow-x:clip, que
      // e o unico jeito de a seta aparecer inteira alem da borda dos cartoes.
      // O || this mantem funcionando a section que ainda nao tiver a casca.
      const escopo = this.closest('[data-carousel-shell]') || this;
      this.prev = escopo.querySelector('[data-carousel-prev]');
      this.next = escopo.querySelector('[data-carousel-next]');
      this.prev?.addEventListener('click', () => this.move(-1));
      this.next?.addEventListener('click', () => this.move(1));
      // Sem o rAF, cada evento de rolagem lia scrollLeft/scrollWidth e logo
      // escrevia hidden/disabled: leitura-escrita-leitura de layout durante o
      // swipe, justamente em cima da vitrine de produtos.
      this.track.addEventListener('scroll', () => this.pedirSync(), { passive: true });
      this.sync();
      window.addEventListener('resize', () => this.pedirSync(), { passive: true });
      this.ligarLoop();
    }

    /* ----- Giro infinito -------------------------------------------------
       Ligado por data-loop="<segundos>". data-loop-below="<px>" limita o giro a
       telas menores que isso — a fileira de vantagens gira no celular, onde so
       cabem dois itens, e fica parada no desktop, onde os quatro ja cabem lado
       a lado e girar seria so ruido.

       O truque do infinito e uma copia da fila inteira no fim. Quando a rolagem
       alcanca a metade, o que esta na tela e o clone do primeiro item; voltar
       para o zero nesse instante nao muda um pixel do que se ve, e a fila
       parece nao ter fim. Sem o clone, o carrossel teria de correr de volta ate
       o comeco na frente da cliente. */
    ligarLoop() {
      const seg = parseFloat(this.dataset.loop || 0);
      if (!(seg > 0)) return;
      const teto = parseInt(this.dataset.loopBelow || 0, 10);
      this._seg = seg;
      // matchMedia e nao window.innerWidth: innerWidth pode ser lido antes de o
      // navegador assentar o layout, e ai a fileira abre o loop achando que
      // esta no celular. No desktop isso aparecia como OITO caixas em vez de
      // quatro — a fila clonada virava uma segunda linha na grade. A consulta
      // de midia responde contra o viewport de verdade e ainda avisa na virada
      // exata do limite, em vez de a cada pixel arrastado.
      this._mq = teto ? window.matchMedia('(max-width:' + (teto - 1) + 'px)') : null;
      this._cabe = () => !this._mq || this._mq.matches;
      this._pausar = () => { clearInterval(this._giro); this._giro = null; };
      this._voltar = () => {
        if (this._giro || !this._loopOn || this._foraDaTela || document.hidden) return;
        this._giro = setInterval(() => this.passo(), this._seg * 1000);
      };
      const rever = () => (this._cabe() ? this.abrirLoop() : this.fecharLoop());
      rever();
      if (this._mq) {
        // addEventListener('change') no lugar do addListener antigo; o Safari
        // so ganhou o moderno na 14, entao vale ter a reserva.
        if (this._mq.addEventListener) this._mq.addEventListener('change', rever);
        else this._mq.addListener(rever);
      }
      // Uma conferida depois que a pagina terminou de carregar: se a primeira
      // leitura pegou o layout no meio do caminho, aqui ela se corrige sozinha
      // em vez de esperar alguem redimensionar a janela.
      window.addEventListener('load', rever, { once: true });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this._pausar(); else this._voltar();
      });
      // Fileira girando fora da tela troca pelas costas e ainda gasta bateria.
      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver((e) => {
          this._foraDaTela = !e[0].isIntersecting;
          if (this._foraDaTela) this._pausar(); else this._voltar();
        });
        this._io.observe(this);
      }
    }
    abrirLoop() {
      if (this._loopOn) return;
      const itens = [...this.track.children];
      if (itens.length < 2) return;
      this._loopOn = true;
      this._clones = itens.map((li) => {
        const c = li.cloneNode(true);
        // O clone e enfeite: sem isto o leitor de tela leria a lista duas vezes
        // e o Tab cairia num link identico ao que a pessoa acabou de passar.
        c.setAttribute('aria-hidden', 'true');
        c.querySelectorAll('a,button,input,select,textarea').forEach((f) => f.setAttribute('tabindex', '-1'));
        this.track.appendChild(c);
        return c;
      });
      // Encostar, tabular ou arrastar para o giro: ninguem le algo que anda
      // sozinho debaixo do dedo.
      ['mouseenter', 'focusin', 'pointerdown'].forEach((ev) => this.addEventListener(ev, this._pausar));
      ['mouseleave', 'focusout', 'pointerup', 'pointercancel'].forEach((ev) => this.addEventListener(ev, this._voltar));
      this._voltar();
    }
    fecharLoop() {
      if (!this._loopOn) return;
      this._loopOn = false;
      this._pausar();
      this._clones?.forEach((c) => c.remove());
      this._clones = null;
      this.track.scrollLeft = 0;
    }
    passo() {
      const metade = this.track.scrollWidth / 2;
      // A volta acontece ANTES de andar, nunca durante a animacao: mexer no
      // scrollLeft no meio de um scroll suave cancela o scroll e a fileira
      // trava. Como o ponto de chegada e visualmente igual ao de partida, o
      // salto e invisivel.
      if (this.track.scrollLeft >= metade - 2) this.track.scrollLeft -= metade;
      this.track.scrollBy({ left: this.track.clientWidth, behavior: comportamentoRolagem() });
    }
    pedirSync() {
      if (this._agendado) return;
      this._agendado = true;
      requestAnimationFrame(() => { this._agendado = false; this.sync(); });
    }
    move(dir) {
      const item = this.track.firstElementChild;
      const passo = item ? item.getBoundingClientRect().width + 16 : this.track.clientWidth * 0.8;
      this.track.scrollBy({ left: passo * dir, behavior: comportamentoRolagem() });
    }
    sync() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const podeRolar = scrollWidth > clientWidth + 4;
      // Botao que nao leva a lugar nenhum some da ordem de tabulacao tambem,
      // nao so da tela.
      [this.prev, this.next].forEach((b) => { if (b) b.hidden = !podeRolar; });
      if (!podeRolar) return;
      // Numa fila que da a volta nao existe primeiro nem ultimo: desabilitar as
      // setas nas pontas diria que acabou, quando na verdade continua.
      if (this._loopOn) {
        if (this.prev) this.prev.disabled = false;
        if (this.next) this.next.disabled = false;
        return;
      }
      if (this.prev) this.prev.disabled = scrollLeft <= 2;
      if (this.next) this.next.disabled = scrollLeft + clientWidth >= scrollWidth - 2;
    }
  }
  customElements.define('fb-carousel', FBCarousel);

  /* ----------------------------------------------------------
     Slideshow (banner)
     ---------------------------------------------------------- */
  class FBSlides extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (this.slides.length < 2) return;
      this.i = 0;
      this.track = this.querySelector('[data-slides-track]') || this;
      this.dots = this.querySelectorAll('[data-slide-dot]');
      // irPara() em vez de go(): clique manual tambem reinicia a contagem do
      // autoplay. Antes, clicar num indicador podia ser atropelado meio segundo
      // depois pela troca automatica que ja estava correndo.
      this.dots.forEach((d, n) => d.addEventListener('click', () => this.irPara(n)));
      this.querySelector('[data-slide-prev]')?.addEventListener('click', () => this.irPara(this.i - 1));
      this.querySelector('[data-slide-next]')?.addEventListener('click', () => this.irPara(this.i + 1));
      this.ligarArrasto();

      const seg = parseInt(this.dataset.autoplay || 0, 10);
      this.seg = seg;
      // Movimento automatico e movimento: quem pediu menos movimento no sistema
      // fica so com os controles manuais.
      // O banner gira mesmo para quem pediu menos movimento no sistema. A regra
      // que vale aqui (WCAG 2.2.2) exige um jeito EXPLICITO de parar o
      // movimento, e ele existe logo abaixo: o botao de pausa ao lado das
      // setas, que so e removido quando nao ha giro nenhum.
      // Respeitar prefers-reduced-motion tambem e boa pratica, mas custava caro
      // nesta loja: no Windows basta desligar as animacoes para o banner parar
      // de vez, e a lojista perde a vitrine que montou sem entender o porque.
      // O que de fato incomoda — o deslizar — segue desligado para essa pessoa
      // pelo CSS; aqui o que muda e so a troca acontecer.
      this.auto = seg > 0;
      const b = this.querySelector('[data-slides-toggle]');
      if (this.auto) {
        this.resume(seg);
        // Passar o mouse ou tabular para dentro pausa: banner que troca sozinho
        // enquanto a pessoa le e sequestro de atencao.
        ['mouseenter', 'focusin'].forEach((ev) => this.addEventListener(ev, () => this.pause()));
        ['mouseleave', 'focusout'].forEach((ev) => this.addEventListener(ev, () => this.resume(seg)));
        // Aba em segundo plano nao precisa de banner girando.
        this._aoTrocarAba = () => { if (document.hidden) this.pause(); else this.resume(seg); };
        document.addEventListener('visibilitychange', this._aoTrocarAba);
        // Banner que gira fora da tela troca pelas costas: quem volta ao topo
        // nao encontra mais o banner que estava vendo.
        if ('IntersectionObserver' in window) {
          this._io = new IntersectionObserver((ents) => {
            this.foraDaTela = !ents[0].isIntersecting;
            if (this.foraDaTela) this.pause(); else this.resume(seg);
          });
          this._io.observe(this);
        }
        // WCAG 2.2.2: movimento automatico acima de 5s precisa de um controle
        // explicito de parar. Hover e foco nao contam.
        if (b) {
          b.addEventListener('click', () => {
            const rodando = !!this.timer;
            this.parado = rodando;
            if (rodando) this.pause(); else this.resume(seg);
            b.setAttribute('aria-pressed', rodando ? 'true' : 'false');
            b.setAttribute('aria-label', rodando ? 'Retomar troca automática' : 'Pausar troca automática');
          });
        }
      } else if (b) {
        // Sem troca automatica nao ha o que pausar. Deixar o botao na tela seria
        // um controle morto no meio do banner — e o atributo [hidden] perderia
        // para o display:grid da classe.
        b.remove();
      }
      this.go(0);
    }
    disconnectedCallback() {
      // O editor de tema arranca e recria a secao a cada mexida: sem limpar, o
      // intervalo antigo segue girando um banner que nao esta mais na pagina.
      this.pause();
      this._io?.disconnect();
      if (this._aoTrocarAba) document.removeEventListener('visibilitychange', this._aoTrocarAba);
    }
    pause() { clearInterval(this.timer); this.timer = null; this.marcarLive(); }
    resume(seg) {
      // parado guarda a escolha de quem clicou em pausar: nem o mouse saindo
      // nem a aba voltando pode religar o movimento por cima dela.
      if (!this.auto || this.timer || this.parado || this.foraDaTela || document.hidden) return;
      this.timer = setInterval(() => this.go(this.i + 1), (seg || this.seg) * 1000);
      this.marcarLive();
    }
    marcarLive() {
      // Enquanto gira sozinho, a troca nao e anunciada — atropelaria a leitura
      // do leitor de tela a cada 7s. Parado, cada troca vira aviso.
      if (this.track && this.track.setAttribute) {
        this.track.setAttribute('aria-live', this.timer ? 'off' : 'polite');
      }
    }
    irPara(n) {
      this.go(n);
      // Reinicia a contagem: depois de um toque manual, a pessoa acabou de
      // comecar a ler aquele banner.
      this.pause();
      this.resume(this.seg);
    }
    /* Arrastar com o dedo. Sem isso o carrossel parece travado no celular, que
       e onde ninguem procura seta. */
    ligarArrasto() {
      const alvo = this.track;
      let x0 = 0; let y0 = 0; let dx = 0; let ativo = false; let decidiu = false;
      // So toque e caneta: arrastar com o mouse briga com a selecao de texto e
      // com o arrasto nativo de imagem e de link.
      alvo.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' || !e.isPrimary) return;
        x0 = e.clientX; y0 = e.clientY; dx = 0; ativo = true; decidiu = false;
        this.arrastou = false;
        this.pause();
      }, { passive: true });
      alvo.addEventListener('pointermove', (e) => {
        if (!ativo) return;
        dx = e.clientX - x0;
        const dy = e.clientY - y0;
        if (!decidiu) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return; // tremida do dedo, ainda nao e gesto
          // Gesto mais vertical que horizontal e rolagem da pagina: sair da frente.
          if (Math.abs(dy) > Math.abs(dx)) { ativo = false; this.soltarArrasto(); this.resume(); return; }
          decidiu = true;
        }
        if (!menosMovimento()) {
          alvo.classList.add('is-drag');
          // A imagem anda menos que o dedo: sem essa resistencia um gesto curto
          // joga o banner para fora da tela e ele volta sem trocar de slide.
          alvo.style.setProperty('--arrasto', (dx * 0.32).toFixed(1) + 'px');
        }
      }, { passive: true });
      const fim = () => {
        if (!ativo) return;
        ativo = false;
        this.soltarArrasto();
        this.arrastou = Math.abs(dx) > 10;
        // 8% da largura, nunca menos que 40px: da 40px no celular de 360 e
        // ~102px no desktop de 1280, sempre acima do tremor de um toque.
        const limite = Math.max(40, alvo.clientWidth * 0.08);
        if (Math.abs(dx) >= limite) this.irPara(this.i + (dx < 0 ? 1 : -1));
        else this.resume();
      };
      alvo.addEventListener('pointerup', fim, { passive: true });
      alvo.addEventListener('pointercancel', fim, { passive: true });
      // O navegador dispara um clique quando o dedo solta: sem esta trava,
      // arrastar em cima do banner abriria o link do slide.
      this.addEventListener('click', (e) => {
        if (!this.arrastou) return;
        this.arrastou = false;
        e.preventDefault();
        e.stopPropagation();
      }, true);
    }
    soltarArrasto() {
      this.track.classList.remove('is-drag');
      this.track.style.removeProperty('--arrasto');
    }
    go(n) {
      const total = this.slides.length;
      this.i = (n + total) % total;
      this.slides.forEach((s, k) => {
        const ativo = k === this.i;
        s.classList.toggle('is-on', ativo);
        // Slide escondido sai da ordem de tabulacao: sem isto o Tab entra em
        // botao invisivel e o foco some da tela.
        s.setAttribute('aria-hidden', ativo ? 'false' : 'true');
        s.querySelectorAll('a,button').forEach((f) => {
          if (ativo) f.removeAttribute('tabindex');
          else f.setAttribute('tabindex', '-1');
        });
      });
      this.dots?.forEach((d, k) => {
        d.classList.toggle('is-on', k === this.i);
        d.setAttribute('aria-current', k === this.i ? 'true' : 'false');
      });
    }
  }
  customElements.define('fb-slides', FBSlides);

  /* ----------------------------------------------------------
     Acordeao
     ---------------------------------------------------------- */
  class FBAccordion extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-acc-head]').forEach((h) => {
        h.addEventListener('click', () => {
          const aberto = h.getAttribute('aria-expanded') === 'true';
          h.setAttribute('aria-expanded', aberto ? 'false' : 'true');
          const corpo = document.getElementById(h.getAttribute('aria-controls'));
          if (corpo) corpo.hidden = aberto;
        });
      });
    }
  }
  customElements.define('fb-accordion', FBAccordion);

  /* ----------------------------------------------------------
     Linha do carrinho: quantidade e remover
     ---------------------------------------------------------- */
  /* Erro da sacola precisa aparecer NA TELA, nao so no aria-live: para quem
     enxerga, falhar em silencio e igual a nao ter clicado. */
  function erroSacola(msg) {
    document.querySelectorAll('[data-cart-error]').forEach((el) => {
      el.textContent = msg;
      el.hidden = false;
    });
    announce(msg, 'assertive');
  }
  function limpaErroSacola() {
    document.querySelectorAll('[data-cart-error]').forEach((el) => {
      el.hidden = true; el.textContent = '';
    });
  }
  function textoErro(err) {
    if (err && err.description) return err.description;
    if (err instanceof TypeError) return 'Sua conexão caiu. Tente de novo.';
    return 'Não foi possível atualizar a sacola.';
  }

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (!input) return;
    const linha = input.closest('[data-line-key]');
    if (!linha) return;
    // O timer vive NA LINHA, nao numa variavel unica do modulo.
    //
    // Com um timer so, mexer na quantidade da segunda peca cancelava o envio
    // da primeira: o campo mostrava 2 e o servidor continuava com 1. A cliente
    // fechava a compra e recebia menos peca do que pediu. Os botoes '+' e '-'
    // disparam o change na hora, entao bastavam dois cliques rapidos em linhas
    // diferentes.
    // Guardar o valor anterior: se a troca falhar, o campo volta ao que era em
    // vez de mostrar um numero que a sacola nao tem.
    const anterior = linha.dataset.lineQty || input.defaultValue;
    linha.dataset.lineQty = input.value;
    clearTimeout(linha._tQty);
    // Quem clica "+" tres vezes seguidas nao pode ter o botao arrancado do dedo
    // entre um clique e outro.
    linha._tQty = setTimeout(async () => {
      limpaErroSacola();
      linha.classList.add('is-busy');
      try {
        await Cart.change(linha.dataset.lineKey, parseInt(input.value, 10));
        await refreshCart();
        // Subtotal e barra de frete mudam; sem anuncio isso acontece em silencio.
        const total = document.querySelector('[data-cart-total]');
        announce('Quantidade atualizada.' + (total ? ' Subtotal ' + total.textContent.trim() : ''));
      } catch (err) {
        input.value = anterior;
        linha.dataset.lineQty = anterior;
        erroSacola(textoErro(err));
      } finally {
        // Sem este finally a linha ficava cinza e morta para sempre.
        linha.classList.remove('is-busy');
      }
    }, 400);
  });

  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-line-remove]');
    if (!b) return;
    e.preventDefault();
    const linha = b.closest('[data-line-key]');
    if (!linha) return;
    limpaErroSacola();
    linha.classList.add('is-busy');
    try {
      await Cart.change(linha.dataset.lineKey, 0);
      await refreshCart();
      announce('Item removido da sacola.');
    } catch (err) {
      erroSacola(textoErro(err));
    } finally {
      linha.classList.remove('is-busy');
    }
  });

  /* ----------------------------------------------------------
     Story / video do feed

     Tres modos, decididos no Liquid:

       file  — video hospedado na Shopify. Passar o mouse toca uma previa muda
               de N segundos, voltando ao inicio; o clique abre o video inteiro,
               com som e controles.
       embed — YouTube ou Vimeo. O clique troca a capa pelo player.
       link  — story, reel ou destaque do Instagram. O clique abre em aba nova:
               o Instagram recusa iframe de fora do dominio dele, entao embutir
               nao e opcao.
     ---------------------------------------------------------- */
  function urlEmbed(url) {
    let m = url.match(/(?:v=|youtu\.be\/|shorts\/|embed\/)([\w-]{11})/);
    if (m) return 'https://www.youtube.com/embed/' + m[1] + '?autoplay=1&rel=0&playsinline=1';
    m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (m) return 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1';
    return '';
  }

  class FBStory extends HTMLElement {
    connectedCallback() {
      this.modo = this.dataset.mode;
      this.url = this.dataset.url || '';
      this.previa = parseFloat(this.dataset.preview) || 3;
      this.video = this.querySelector('video');
      this.aberto = false;

      if (this.modo === 'file' && this.video) {
        // Previa so com mouse de verdade: no celular nao existe hover, e tocar
        // video sozinho ali gastaria dado da cliente sem ela pedir.
        if (window.matchMedia('(hover:hover)').matches && !menosMovimento()) {
          this.addEventListener('mouseenter', () => this.espiar());
          this.addEventListener('mouseleave', () => this.parar());
        }
        this.video.addEventListener('timeupdate', () => {
          if (!this.aberto && this.video.currentTime >= this.previa) {
            try { this.video.currentTime = 0; } catch (_) {}
          }
        });
      }

      this.addEventListener('click', (e) => {
        if (e.target.closest('a')) return;
        this.abrir();
      });
      this.querySelector('[class*="vitem__play"]')?.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.abrir(); }
      });
    }

    espiar() {
      if (this.aberto || !this.video) return;
      this.video.muted = true;
      this.video.play()?.catch(() => {});
    }
    parar() {
      if (this.aberto || !this.video) return;
      this.video.pause();
      try { this.video.currentTime = 0; } catch (_) {}
    }

    abrir() {
      if (this.modo === 'file' && this.video) {
        if (this.aberto) return;
        this.aberto = true;
        this.video.muted = false;
        this.video.loop = false;
        this.video.controls = true;
        try { this.video.currentTime = 0; } catch (_) {}
        this.classList.add('is-playing');
        this.video.play()?.catch(() => {});
        return;
      }
      if (!this.url) return;
      const emb = this.modo === 'embed' ? urlEmbed(this.url) : '';
      if (emb) {
        const f = document.createElement('iframe');
        f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        f.setAttribute('allowfullscreen', '');
        f.setAttribute('title', 'Vídeo');
        f.loading = 'lazy';
        f.src = emb;
        this.innerHTML = '';
        this.appendChild(f);
        this.classList.add('is-playing');
        return;
      }
      // Story do Instagram e tudo mais: abre fora.
      window.open(this.url, '_blank', 'noopener');
    }
  }
  customElements.define('fb-story', FBStory);

  /* ----------------------------------------------------------
     Busca com sugestao
     ---------------------------------------------------------- */
  class FBSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.out = this.querySelector('[data-search-results]');
      if (!this.input || !this.out) return;
      let t;
      this.input.addEventListener('input', () => {
        clearTimeout(t);
        const termo = this.input.value.trim();
        if (termo.length < 2) { this.out.hidden = true; return; }
        // Espera a digitacao parar: sem isto e uma requisicao por tecla.
        t = setTimeout(() => this.buscar(termo), 260);
      });
      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) this.out.hidden = true;
      });
    }
    async buscar(termo) {
      const url = `/search/suggest?q=${encodeURIComponent(termo)}`
        + '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
      // Sem isto o painel segurava o resultado da busca anterior e a cliente
      // clicava num produto que nao correspondia ao que ela digitou.
      this.out.innerHTML = '<p class="suggest__empty">Buscando…</p>';
      this.out.hidden = false;
      try {
        const html = await fetch(url).then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const bloco = doc.querySelector('[data-search-results]');
        if (bloco) this.out.innerHTML = bloco.innerHTML;
      } catch (_) {
        this.out.innerHTML = '<p class="suggest__empty">Não conseguimos buscar agora.</p>';
      }
    }
  }
  customElements.define('fb-search', FBSearch);

  /* Cabecalho que gruda ao rolar para cima. */
  const header = document.querySelector('[data-header]');
  if (header) {
    let ultimo = window.scrollY;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      header.classList.toggle('is-stuck', y > 8);
      header.classList.toggle('is-hidden', y > 240 && y > ultimo);
      ultimo = y;
    }, { passive: true });
    // Shift+Tab de volta para o cabecalho escondido deixava o foco fora da tela.
    header.addEventListener('focusin', () => header.classList.remove('is-hidden'));
  }

  /* ----------------------------------------------------------
     MEGA MENU
     Painel grande abaixo do cabecalho. Nao virou custom element de
     proposito: ele nao tem marcacao propria para embrulhar — vive dentro
     do <li> do menu, que quem desenha e o Liquid da navegacao.

     Abre no mouse E no teclado. O 'hidden' e' quem manda de verdade: sem
     ele o painel continua na arvore de acessibilidade e o leitor de tela
     anuncia seis categorias invisiveis em toda pagina.
     ---------------------------------------------------------- */
  (() => {
    const pais = document.querySelectorAll('[data-mega-pai]');
    if (!pais.length) return;

    // A consulta fica VIVA. Lida uma vez no carregamento, um aparelho que muda
    // de modo (tablet que ganha teclado, janela redimensionada, telefone
    // dobravel) ficava preso no comportamento errado: menu que nao abre no
    // mouse, ou que exige dois toques onde um bastaria.
    const mqHover = window.matchMedia('(hover: hover)');
    let aberto = null;
    let timer = null;

    const fechar = (li, naHora) => {
      if (!li) return;
      const painel = li.querySelector('[data-mega]');
      const gatilho = li.querySelector('[data-mega-gatilho]');
      if (!painel) return;
      painel.classList.remove('is-open');
      if (gatilho) gatilho.setAttribute('aria-expanded', 'false');
      if (aberto === li) aberto = null;
      /* Espera a transicao antes do hidden: aplicar os dois no mesmo quadro
         corta o fade pela metade. Com menos movimento pedido, some na hora. */
      const espera = (naHora || menosMovimento()) ? 0 : 280;
      clearTimeout(painel._fim);
      painel._fim = setTimeout(() => {
        if (!painel.classList.contains('is-open')) painel.hidden = true;
      }, espera);
    };

    const abrir = (li) => {
      if (aberto === li) return;
      if (aberto) fechar(aberto, true);
      const painel = li.querySelector('[data-mega]');
      const gatilho = li.querySelector('[data-mega-gatilho]');
      if (!painel) return;
      clearTimeout(painel._fim);
      painel.hidden = false;
      if (gatilho) gatilho.setAttribute('aria-expanded', 'true');
      /* Dois quadros: o primeiro so tira o display:none, e transicao a partir
         de display:none nao roda. */
      requestAnimationFrame(() => requestAnimationFrame(() => {
        painel.classList.add('is-open');
      }));
      aberto = li;
    };

    pais.forEach((li) => {
      const gatilho = li.querySelector('[data-mega-gatilho]');
      const painel = li.querySelector('[data-mega]');
      if (!gatilho || !painel) return;

      if (mqHover.matches) {
        /* Atraso curto na entrada e na saida: sem ele, atravessar o menu ate'
           o ultimo item pisca todos os paineis pelo caminho, e um desvio de
           2px do mouse ao descer para o painel fecha ele na cara da cliente. */
        li.addEventListener('mouseenter', () => {
          clearTimeout(timer);
          timer = setTimeout(() => abrir(li), 90);
        });
        li.addEventListener('mouseleave', () => {
          clearTimeout(timer);
          timer = setTimeout(() => fechar(li), 180);
        });
      } else {
        /* Sem mouse, o primeiro toque abre em vez de navegar. O segundo segue
           o link — e' o que a pessoa espera, e o link continua funcionando sem
           JS nenhum. */
        gatilho.addEventListener('click', (e) => {
          if (aberto !== li) { e.preventDefault(); abrir(li); }
        });
      }

      /* Teclado: entrar no item abre, sair do item inteiro fecha. focusout
         dispara ANTES do foco pousar, dai o relatedTarget. */
      li.addEventListener('focusin', () => abrir(li));
      li.addEventListener('focusout', (e) => {
        if (!li.contains(e.relatedTarget)) fechar(li, true);
      });

      painel.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { fechar(li, true); gatilho.focus(); }
      });
      gatilho.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && aberto === li) { fechar(li, true); gatilho.focus(); }
      });
    });

    /* Rolar a pagina com o painel aberto deixa ele plantado no meio da tela. */
    window.addEventListener('scroll', () => { if (aberto) fechar(aberto, true); },
      { passive: true });
  })();

})();
